export default {
  src: 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js',
  autoBlockSrc:
    'https://cdn.cookielaw.org/consent/018fe211-e22f-7cc1-a6d3-dc9dc23e1bc7/OtAutoBlock.js',
  domainScript: '018fe211-e22f-7cc1-a6d3-dc9dc23e1bc7',
};
